module.exports = __webpack_public_path__ + "static/media/IMG_20180203_100236.7d0711df.jpg";